webpackJsonp([5],{

/***/ "5/4G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__2OR2-","mainTitleWrapper":"mainTitleWrapper__3B2dN","tabsWrapper":"tabsWrapper__3Wl4-","active":"active__2VlTk","filtersMainWrapper":"filtersMainWrapper__3nErY","filtersWrapper":"filtersWrapper__2goQu","exportWrapper":"exportWrapper__AAL9p","mapWrapper":"mapWrapper__1PIkr","summaryDataWrapper":"summaryDataWrapper__248nV","contributionsWrapper":"contributionsWrapper__2AayE","contributionRowWrapper":"contributionRowWrapper__3FhZq","contributionSummaryWrapper":"contributionSummaryWrapper__1hctl","yearSelectorWrapper":"yearSelectorWrapper__334_F","portalsChartWrapper":"portalsChartWrapper__3ssiP","sdgsChartWrapper":"sdgsChartWrapper__3Help","sectorsChartWrapper":"sectorsChartWrapper__2zyka","disclaimerText":"disclaimerText__1IwdN"};

/***/ }),

/***/ "AYL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__("rhVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", null);

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      value: ""
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onSelect = _this.onSelect.bind(_this);
    _this.clearSearch = _this.clearSearch.bind(_this);
    return _this;
  }

  Select.prototype.onChange = function onChange(event) {
    var _props = this.props,
        onFilter = _props.onFilter,
        filters = _props.filters;

    this.setState({ value: event.target.value });
    var queryParams = null;
    if (filters) {
      queryParams = (event.target.value + "&\n                    year=" + filters.year + "&\n                    portal=" + filters.portal + "&\n                    field_of_operation=" + filters.field_of_operation + "&\n                    donor=" + filters.donor + "&\n                    oecd=" + filters.oecd + "&\n                    sdg=" + filters.sdg).replace(/  +/g, "");
    } else {
      queryParams = "" + event.target.value;
    }
    onFilter(queryParams);
  };

  Select.prototype.onSelect = function onSelect(option) {
    this.props.onSelect(option.value);
    this.setState({ value: option.label });
    this.props.onFilter("");
  };

  Select.prototype.clearSearch = function clearSearch() {
    this.props.onSelect("");
    this.setState({ value: "" });
    this.props.onFilter("");
  };

  Select.prototype.render = function render() {
    var _this2 = this;

    var value = this.state.value;
    var _props2 = this.props,
        label = _props2.label,
        options = _props2.options;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.mainWrapper },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "span",
        null,
        label
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", {
          placeholder: "Search for an item",
          type: "text",
          onInput: this.onChange,
          value: value
        }),
        value ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "fas fa-times", onClick: this.clearSearch }) : _ref
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        null,
        options.map(function (option) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { key: option.key, onClick: function onClick() {
                return _this2.onSelect(option);
              } },
            option.label
          );
        })
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),

/***/ "V45N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sectionsWrapper":"sectionsWrapper__3ustW","chartWrapper":"chartWrapper__2L_Z9","legendWrapper":"legendWrapper__3dJNL"};

/***/ }),

/***/ "iOg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./routes/home/components/main/style.css
var style = __webpack_require__("qVNc");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/yearSelector/index.js
var yearSelector = __webpack_require__("imAB");

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./components/home-map-with-tabs/style.scss
var home_map_with_tabs_style = __webpack_require__("5/4G");
var home_map_with_tabs_style_default = /*#__PURE__*/__webpack_require__.n(home_map_with_tabs_style);

// EXTERNAL MODULE: ./components/select/index.js
var components_select = __webpack_require__("AYL1");

// EXTERNAL MODULE: ./components/activities-map/index.js + 2 modules
var activities_map = __webpack_require__("EbT9");

// EXTERNAL MODULE: ./components/pie-chart/style.scss
var pie_chart_style = __webpack_require__("V45N");
var pie_chart_style_default = /*#__PURE__*/__webpack_require__.n(pie_chart_style);

// EXTERNAL MODULE: ./components/doughnutChart/index.js
var doughnutChart = __webpack_require__("hQeX");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// CONCATENATED MODULE: ./components/pie-chart/index.js





var options = {
  maintainAspectRatio: true,
  tooltips: {
    callbacks: {
      label: function label(tooltipItem, data) {
        var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        return parseInt(tooltipValue).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }
    }
  }
};

var _ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref2 = Object(preact_min["h"])("div", null);

var pie_chart_PieChart = function PieChart(props) {
  if (props.loading) return _ref;
  if (!props.data.datasets || !props.data.datasets.length || !props.data.datasets[0].data.length) return _ref2;
  return Object(preact_min["h"])(
    "div",
    { className: pie_chart_style_default.a.sectionsWrapper, style: { display: "block" } },
    Object(preact_min["h"])(
      "div",
      { className: pie_chart_style_default.a.chartWrapper },
      Object(preact_min["h"])(doughnutChart["a" /* default */], {
        width: 10,
        height: 10,
        data: props.data,
        options: options
      }),
      Object(preact_min["h"])(
        "div",
        { className: pie_chart_style_default.a.legendWrapper },
        Object(preact_min["h"])(
          "b",
          null,
          "$" + (props.totalValue / 1000000).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + "M"
        ),
        Object(preact_min["h"])(
          "span",
          null,
          props.title
        )
      )
    )
  );
};

/* harmony default export */ var pie_chart = (pie_chart_PieChart);
// EXTERNAL MODULE: ./shared/actions/getFiltersData.js
var getFiltersData = __webpack_require__("6dIb");

// EXTERNAL MODULE: ./shared/actions/getPieChartData.js
var getPieChartData = __webpack_require__("2q2G");

// EXTERNAL MODULE: ./shared/actions/mapActions/getHomeMapData.js
var mapActions_getHomeMapData = __webpack_require__("Ann0");

// EXTERNAL MODULE: ./shared/actions/getHomeMapSummaryData.js
var actions_getHomeMapSummaryData = __webpack_require__("lwp9");

// EXTERNAL MODULE: ./shared/actions/getHomeDonorsContributionsList.js
var actions_getHomeDonorsContributionsList = __webpack_require__("Onlx");

// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__("DHvs");

// EXTERNAL MODULE: ./shared/actions/getYearList.js
var getYearList = __webpack_require__("EIKz");

// CONCATENATED MODULE: ./components/home-map-with-tabs/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */















var adaptPieChartData = function adaptPieChartData(data) {
  return data.sectors ? {
    datasets: [{
      data: data.sectors.map(function (item) {
        return item.percentage;
      }),
      backgroundColor: data.sectors.map(function (item) {
        return "#" + item.color;
      })
    }],
    titles: data.sectors.map(function (item) {
      return item.name;
    }),
    labels: data.sectors.map(function (item) {
      return "Budget: $" + (item.budget / 1000000).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + "M | Expense: $" + (item.expense / 1000000).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + "M";
    })
  } : [];
};

var getPieChartTotalValue = function getPieChartTotalValue(data) {
  return data.sectors ? data.sectors.reduce(function (total, item) {
    return total + item.expense;
  }, 0) : 0;
};

var adaptPieChartLegend = function adaptPieChartLegend(data) {
  return data.sectors ? data.sectors : [];
};

var home_map_with_tabs__ref = Object(preact_min["h"])(
  "h1",
  null,
  "Explore"
);

var home_map_with_tabs__ref2 = Object(preact_min["h"])(
  "span",
  null,
  "Learn more about where and how UNRWA is making a difference"
);

var _ref3 = Object(preact_min["h"])("div", null);

var _ref4 = Object(preact_min["h"])("i", { className: "fas fa-download" });

var _ref5 = Object(preact_min["h"])(
  "span",
  null,
  "Export"
);

var _ref6 = Object(preact_min["h"])(
  "b",
  null,
  "Global"
);

var _ref7 = Object(preact_min["h"])(
  "span",
  null,
  "Budget"
);

var _ref8 = Object(preact_min["h"])(
  "span",
  null,
  "Expense"
);

var _ref9 = Object(preact_min["h"])(
  "span",
  null,
  "Activities"
);

var _ref10 = Object(preact_min["h"])(
  "span",
  null,
  "Donors"
);

var _ref11 = Object(preact_min["h"])(
  "small",
  null,
  "Contributions"
);

var _ref12 = Object(preact_min["h"])("div", null);

var _ref13 = Object(preact_min["h"])("div", null);

var _ref14 = Object(preact_min["h"])("div", null);

var _ref15 = Object(preact_min["h"])("div", null);

var _ref16 = Object(preact_min["h"])("div", null);

var home_map_with_tabs_HomeMapWithTabs = function (_Component) {
  _inherits(HomeMapWithTabs, _Component);

  function HomeMapWithTabs(props) {
    _classCallCheck(this, HomeMapWithTabs);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      field: undefined,
      donor: undefined,
      sdg: undefined,
      sector: undefined,
      year: _this.props.year,
      selectedTab: 0
    };
    _this.onSelectField = _this.onSelectField.bind(_this);
    _this.onSelectYear = _this.onSelectYear.bind(_this);
    _this.onSelectTab = _this.onSelectTab.bind(_this);
    _this.onSelectDonor = _this.onSelectDonor.bind(_this);
    _this.onSelectSdg = _this.onSelectSdg.bind(_this);
    _this.onSelectSector = _this.onSelectSector.bind(_this);
    return _this;
  }

  HomeMapWithTabs.prototype.componentDidMount = function componentDidMount() {
    this.props.getHomeMapData(this.state.year, this.state.field);
    this.props.getHomeMapSummaryData(this.state.year, this.state.field);
  };

  HomeMapWithTabs.prototype.onSelectField = function onSelectField(field) {
    this.setState({ field: field });
    switch (this.state.selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, field);
        this.props.getHomeMapSummaryData(this.state.year, field);
        break;
      case 1:
        this.props.getHomeMapData(this.state.year, field, this.state.donor);
        this.props.getHomeMapSummaryData(this.state.year, field, this.state.donor);
        this.props.getHomeDonorsContributionsList(this.state.year, field, this.state.donor);
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, field);
        this.props.getHomeMapSummaryData(this.state.year, field);
        this.props.getHomePortalsPieChartData(this.state.year, field);
        break;
      case 3:
        this.props.getHomeMapData(this.state.year, field, undefined, this.state.sdg);
        this.props.getHomeMapSummaryData(this.state.year, field, undefined, this.state.sdg);
        this.props.getHomeSdgsPieChartData(this.state.year, field);
        break;
      case 4:
        this.props.getHomeMapData(this.state.year, field, undefined, this.state.sector);
        this.props.getHomeMapSummaryData(this.state.year, field, undefined, this.state.sector);
        this.props.getHomeSectorsPieChartData(this.state.year, field);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.onSelectDonor = function onSelectDonor(donor) {
    this.setState({ donor: donor });
    switch (this.state.selectedTab) {
      case 1:
        this.props.getHomeMapData(this.state.year, this.state.field, donor);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, donor);
        this.props.getHomeDonorsContributionsList(this.state.year, this.state.field, donor);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.onSelectYear = function onSelectYear(year) {
    this.setState({ year: year });
    this.props.setCurrentYear(year);

    switch (this.state.selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        break;
      case 1:
        this.props.getHomeMapData(this.state.year, this.state.field, this.state.donor);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, this.state.donor);
        this.props.getHomeDonorsContributionsList(this.state.year, this.state.field, this.state.donor);
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        this.props.getHomePortalsPieChartData(this.state.year, this.state.field);
        break;
      case 3:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, this.state.sdg);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, this.state.sdg);
        this.props.getHomeSdgsPieChartData(this.state.year, this.state.field);
        break;
      case 4:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, this.state.sector);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, this.state.sector);
        this.props.getHomeSectorsPieChartData(this.state.year, this.state.field);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.onSelectSdg = function onSelectSdg(sdg) {
    this.setState({ sdg: sdg });
    switch (this.state.selectedTab) {
      case 3:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, sdg);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, sdg);
        this.props.getHomeSdgsPieChartData(this.state.year, this.state.field, sdg);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.onSelectSector = function onSelectSector(sector) {
    this.setState({ sector: sector });
    switch (this.state.selectedTab) {
      case 4:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, sector);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, sector);
        this.props.getHomeSectorsPieChartData(this.state.year, this.state.field, sector);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.onSelectTab = function onSelectTab(selectedTab) {
    this.setState({ selectedTab: selectedTab });
    switch (selectedTab) {
      case 0:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        break;
      case 1:
        this.props.getHomeMapData(this.state.year, this.state.field, this.state.donor);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, this.state.donor);
        this.props.getHomeDonorsContributionsList(this.state.year, this.state.field, this.state.donor);
        break;
      case 2:
        this.props.getHomeMapData(this.state.year, this.state.field);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field);
        this.props.getHomePortalsPieChartData(this.state.year, this.state.field);
        break;
      case 3:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, this.state.sdg);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, this.state.sdg);
        this.props.getHomeSdgsPieChartData(this.state.year, this.state.field);
        break;
      case 4:
        this.props.getHomeMapData(this.state.year, this.state.field, undefined, this.state.sector);
        this.props.getHomeMapSummaryData(this.state.year, this.state.field, undefined, this.state.sector);
        this.props.getHomeSectorsPieChartData(this.state.year, this.state.field);
        break;
      default:
        break;
    }
  };

  HomeMapWithTabs.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        homeFields = _props.homeFields,
        getHomeFields = _props.getHomeFields,
        homeMapData = _props.homeMapData,
        homeMapSummaryData = _props.homeMapSummaryData,
        getHomeDonors = _props.getHomeDonors,
        homeDonors = _props.homeDonors,
        homeDonorsContributionsList = _props.homeDonorsContributionsList,
        homePortalsPieChartData = _props.homePortalsPieChartData,
        getHomeSdgs = _props.getHomeSdgs,
        homeSdgs = _props.homeSdgs,
        homeSdgsPieChartData = _props.homeSdgsPieChartData,
        homeSectors = _props.homeSectors,
        homeSectorsPieChartData = _props.homeSectorsPieChartData,
        getHomeSectors = _props.getHomeSectors;
    var _state = this.state,
        field = _state.field,
        year = _state.year,
        selectedTab = _state.selectedTab;

    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "div",
        { className: home_map_with_tabs_style_default.a.mainWrapper },
        Object(preact_min["h"])(
          "div",
          { className: home_map_with_tabs_style_default.a.mainTitleWrapper },
          home_map_with_tabs__ref,
          home_map_with_tabs__ref2
        ),
        Object(preact_min["h"])(
          "div",
          { className: home_map_with_tabs_style_default.a.tabsWrapper },
          Object(preact_min["h"])(
            "ul",
            null,
            Object(preact_min["h"])(
              "li",
              {
                className: selectedTab === 0 ? home_map_with_tabs_style_default.a.active : undefined,
                onClick: function onClick() {
                  return _this2.onSelectTab(0);
                }
              },
              "Fields of operations"
            ),
            Object(preact_min["h"])(
              "li",
              {
                className: selectedTab === 1 ? home_map_with_tabs_style_default.a.active : undefined,
                onClick: function onClick() {
                  return _this2.onSelectTab(1);
                }
              },
              "Donors"
            ),
            Object(preact_min["h"])(
              "li",
              {
                className: selectedTab === 2 ? home_map_with_tabs_style_default.a.active : undefined,
                onClick: function onClick() {
                  return _this2.onSelectTab(2);
                }
              },
              "Portals"
            ),
            Object(preact_min["h"])(
              "li",
              {
                className: selectedTab === 4 ? home_map_with_tabs_style_default.a.active : undefined,
                onClick: function onClick() {
                  return _this2.onSelectTab(4);
                }
              },
              "Sectors"
            ),
            Object(preact_min["h"])(
              "li",
              {
                className: selectedTab === 3 ? home_map_with_tabs_style_default.a.active : undefined,
                onClick: function onClick() {
                  return _this2.onSelectTab(3);
                }
              },
              "SDGs"
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: home_map_with_tabs_style_default.a.filtersMainWrapper },
          Object(preact_min["h"])(
            "div",
            { className: home_map_with_tabs_style_default.a.filtersWrapper },
            Object(preact_min["h"])(
              "div",
              { className: home_map_with_tabs_style_default.a.yearSelectorWrapper },
              Object(preact_min["h"])(yearSelector["a" /* default */], {
                selectedYear: this.props.globalSelectedYear,
                onSelectYear: this.onSelectYear
              })
            ),
            Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(components_select["a" /* default */], {
                label: "Field of operations",
                onFilter: getHomeFields,
                onSelect: this.onSelectField,
                options: homeFields.map(function (item) {
                  return {
                    key: item.code,
                    label: item.name,
                    value: item.name
                  };
                })
              })
            ),
            selectedTab === 1 ? Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(components_select["a" /* default */], {
                label: "Donors",
                onFilter: getHomeDonors,
                onSelect: this.onSelectDonor,
                options: homeDonors.map(function (item) {
                  return {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  };
                })
              })
            ) : _ref3
          ),
          Object(preact_min["h"])(
            "div",
            { style: { display: "none" }, className: home_map_with_tabs_style_default.a.exportWrapper },
            _ref4,
            _ref5
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: home_map_with_tabs_style_default.a.mapWrapper },
          Object(preact_min["h"])(activities_map["a" /* default */], { mapData: homeMapData }),
          homeMapData.data.length ? Object(preact_min["h"])(
            "div",
            { className: home_map_with_tabs_style_default.a.summaryDataWrapper },
            Object(preact_min["h"])(
              "div",
              null,
              field ? Object(preact_min["h"])(
                "b",
                null,
                Object(preact_min["h"])(
                  "a",
                  { href: "/profile/" + field + "/recipientprofile" },
                  field
                )
              ) : _ref6
            ),
            Object(preact_min["h"])(
              "div",
              null,
              Object(preact_min["h"])(
                "div",
                null,
                Object(preact_min["h"])(
                  "b",
                  null,
                  Object(utils["a" /* formatNumber */])(homeMapSummaryData.budgets / 1000000),
                  "m"
                ),
                _ref7
              ),
              Object(preact_min["h"])(
                "div",
                null,
                Object(preact_min["h"])(
                  "b",
                  null,
                  Object(utils["a" /* formatNumber */])(homeMapSummaryData.expenses / 1000000),
                  "m"
                ),
                _ref8
              ),
              Object(preact_min["h"])(
                "div",
                null,
                Object(preact_min["h"])(
                  "b",
                  null,
                  Object(utils["b" /* formatNumberNoFractionDigits */])(homeMapSummaryData.activities)
                ),
                _ref9
              ),
              Object(preact_min["h"])(
                "div",
                null,
                Object(preact_min["h"])(
                  "b",
                  null,
                  Object(utils["b" /* formatNumberNoFractionDigits */])(homeMapSummaryData.donors)
                ),
                _ref10
              )
            ),
            selectedTab === 1 && homeDonorsContributionsList.donors ? Object(preact_min["h"])(
              "div",
              { className: home_map_with_tabs_style_default.a.contributionsWrapper },
              homeDonorsContributionsList.donors.map(function (item) {
                return Object(preact_min["h"])(
                  "div",
                  {
                    key: "donor_contribution_" + item.donor_code,
                    className: home_map_with_tabs_style_default.a.contributionRowWrapper
                  },
                  Object(preact_min["h"])(
                    "a",
                    {
                      href: "/profile/" + item.donor_code + "/donorprofile",
                      alt: item.donor_name
                    },
                    Object(preact_min["h"])(
                      "h4",
                      null,
                      item.donor_name
                    )
                  ),
                  Object(preact_min["h"])(
                    "div",
                    { className: home_map_with_tabs_style_default.a.contributionSummaryWrapper },
                    Object(preact_min["h"])(
                      "b",
                      null,
                      Object(utils["a" /* formatNumber */])(item.contributions / 1000000) + "m"
                    ),
                    _ref11
                  )
                );
              })
            ) : _ref12,
            selectedTab === 2 && homePortalsPieChartData.data.sectors && homePortalsPieChartData.data.sectors.length ? Object(preact_min["h"])(
              "div",
              { className: home_map_with_tabs_style_default.a.portalsChartWrapper },
              Object(preact_min["h"])(pie_chart, {
                title: "Total Budget",
                data: adaptPieChartData(homePortalsPieChartData.data),
                legendData: adaptPieChartLegend(homePortalsPieChartData.data),
                loading: homePortalsPieChartData.loading,
                totalValue: getPieChartTotalValue(homePortalsPieChartData.data)
              })
            ) : _ref13,
            selectedTab === 3 && homeSdgsPieChartData.data.sectors && homeSdgsPieChartData.data.sectors.length ? Object(preact_min["h"])(
              "div",
              { className: home_map_with_tabs_style_default.a.sdgsChartWrapper },
              Object(preact_min["h"])(pie_chart, {
                title: "Total Budget",
                data: adaptPieChartData(homeSdgsPieChartData.data),
                legendData: adaptPieChartLegend(homeSdgsPieChartData.data),
                loading: homeSdgsPieChartData.loading,
                totalValue: getPieChartTotalValue(homeSdgsPieChartData.data)
              }),
              Object(preact_min["h"])(
                "div",
                {
                  style: {
                    textAlign: "center",
                    fontSize: "0.85rem",
                    padding: "1.5rem 3rem"
                  }
                },
                "* SDG mapping is provided only for non-humanitarian activities"
              )
            ) : _ref14,
            selectedTab === 4 && homeSectorsPieChartData.data.sectors && homeSectorsPieChartData.data.sectors.length ? Object(preact_min["h"])(
              "div",
              { className: home_map_with_tabs_style_default.a.sectorsChartWrapper },
              Object(preact_min["h"])(pie_chart, {
                title: "Total Budget",
                data: adaptPieChartData(homeSectorsPieChartData.data),
                legendData: adaptPieChartLegend(homeSectorsPieChartData.data),
                loading: homeSectorsPieChartData.loading,
                totalValue: getPieChartTotalValue(homeSectorsPieChartData.data)
              })
            ) : _ref15
          ) : _ref16
        )
      ),
      Object(preact_min["h"])(
        "div",
        { "class": home_map_with_tabs_style_default.a.disclaimerText },
        "* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of the Secretariat of the United Nations or UNRWA concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries. State of Palestine includes West Bank, East Jerusalem and the Gaza Strip."
      )
    );
  };

  return HomeMapWithTabs;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    homeFields: state.homeFields.data,
    homeDonors: state.homeDonors.data,
    homeSdgs: state.homeSdgs.data,
    homeSectors: state.homeSectors.data,
    homeMapData: state.homeMapData,
    homeMapSummaryData: state.homeMapSummaryData.data,
    homeDonorsContributionsList: state.homeDonorsContributionsList.data,
    year: state.yearList.currentYear,
    homePortalsPieChartData: state.homePortalsPieChartData,
    homeSdgsPieChartData: state.homeSdgsPieChartData,
    homeSectorsPieChartData: state.homeSectorsPieChartData,
    globalSelectedYear: state.yearList.currentYear

  };
};

var home_map_with_tabs_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getHomeFields: function getHomeFields(filter) {
      return dispatch(getFiltersData["a" /* default */].getHomeFields(filter));
    },
    getHomeDonors: function getHomeDonors(filter) {
      return dispatch(getFiltersData["a" /* default */].getHomeDonors(filter));
    },
    getHomeSdgs: function getHomeSdgs(filter) {
      return dispatch(getFiltersData["a" /* default */].getHomeSdgs(filter));
    },
    getHomeSectors: function getHomeSectors(filter) {
      return dispatch(getFiltersData["a" /* default */].getHomeSectors(filter));
    },
    getHomeMapData: function getHomeMapData(year, field, donor, vocabulary) {
      return dispatch(Object(mapActions_getHomeMapData["b" /* getHomeMapData */])(year, field, donor, vocabulary));
    },
    getHomeMapSummaryData: function getHomeMapSummaryData(year, field, donor, vocabulary) {
      return dispatch(Object(actions_getHomeMapSummaryData["b" /* getHomeMapSummaryData */])(year, field, donor, vocabulary));
    },
    getHomeDonorsContributionsList: function getHomeDonorsContributionsList(year, field, donor) {
      return dispatch(Object(actions_getHomeDonorsContributionsList["b" /* getHomeDonorsContributionsList */])(year, field, donor));
    },
    getHomePortalsPieChartData: function getHomePortalsPieChartData(year, field) {
      return dispatch(getPieChartData["a" /* default */].getHomePortalsPieChartData(year, field));
    },
    getHomeSdgsPieChartData: function getHomeSdgsPieChartData(year, field) {
      return dispatch(getPieChartData["a" /* default */].getHomeSdgsPieChartData(year, field, 7));
    },
    getHomeSectorsPieChartData: function getHomeSectorsPieChartData(year, field) {
      return dispatch(getPieChartData["a" /* default */].getHomeSectorsPieChartData(year, field, 2));
    },
    setCurrentYear: function setCurrentYear(year) {
      return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
    }

  };
};

/* harmony default export */ var home_map_with_tabs = (Object(preact_redux_esm["b" /* connect */])(mapStateToProps, home_map_with_tabs_mapDispatchToProps)(home_map_with_tabs_HomeMapWithTabs));
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/tmp_home_financial_component/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("iY4Q") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var tmp_home_financial_component = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/home/components/main/index.js


function main__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function main__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function main__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var main__ref = Object(preact_min["h"])(
  "div",
  null,
  Object(preact_min["h"])("img", {
    src: "/static/assets/images/home_logo.png",
    alt: "United Nations"
  })
);

var main__ref2 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "a",
    { alt: "Activities", href: "/projects" },
    "Activities"
  )
);

var main__ref3 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "a",
    { alt: "Donors", href: "/donors" },
    "Donors"
  )
);

var main__ref4 = Object(preact_min["h"])(
  "li",
  null,
  Object(preact_min["h"])(
    "a",
    { alt: "Sectors", href: "/sustainable-development-goals" },
    "Sectors"
  )
);

var main__ref5 = Object(preact_min["h"])(
  "button",
  null,
  Object(preact_min["h"])("i", { className: "fas fa-search" })
);

var main__ref6 = Object(preact_min["h"])(
  "span",
  null,
  "unrwa transparency portal"
);

var main__ref7 = Object(preact_min["h"])(
  "p",
  null,
  "UNRWA is a United Nations agency established by the General Assembly in 1949 and mandated to provide assistance and protection to 5.7 million Palestine refugees registered with the Agency in Jordan, Lebanon, Syria, West Bank, including East Jerusalem and the Gaza Strip to achieve their full human development potential, pending a just and lasting solution to their plight."
);

var main__ref8 = Object(preact_min["h"])("input", {
  type: "text",
  placeholder: "Search Activities, Donors, Recipients and more"
});

var main__ref9 = Object(preact_min["h"])("i", { className: "fas fa-search" });

var main__ref10 = Object(preact_min["h"])("i", { className: "fas fa-spinner" });

var main__ref11 = Object(preact_min["h"])(
  "span",
  null,
  "Budget"
);

var main__ref12 = Object(preact_min["h"])(
  "span",
  null,
  "Expense"
);

var main__ref13 = Object(preact_min["h"])(
  "span",
  null,
  "Activities"
);

var main__ref14 = Object(preact_min["h"])(
  "span",
  null,
  "Donors"
);

var main__ref15 = Object(preact_min["h"])(home_map_with_tabs, null);

var main__ref16 = Object(preact_min["h"])(tmp_home_financial_component, null);

var _ref17 = Object(preact_min["h"])(
  "h1",
  null,
  "Making an impact"
);

var _ref18 = Object(preact_min["h"])(
  "p",
  null,
  "UNRWA is a United Nations agency established by the General Assembly in 1949 and mandated to provide assistance and protection to 5.7 million Palestine refugees registered with the Agency in Jordan, Lebanon, Syria, West Bank, including East Jerusalem and the Gaza Strip to achieve their full human development potential, pending a just and lasting solution to their plight."
);

var _ref19 = Object(preact_min["h"])("i", { className: "fas fa-medkit" });

var _ref20 = Object(preact_min["h"])(
  "span",
  null,
  "Health"
);

var _ref21 = Object(preact_min["h"])(
  "p",
  null,
  "Over 3 million refugees accessing our health services with more than 8 million annual patient visits.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/health",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref22 = Object(preact_min["h"])("i", { className: "fas fa-user-shield" });

var _ref23 = Object(preact_min["h"])(
  "span",
  null,
  "Protection"
);

var _ref24 = Object(preact_min["h"])(
  "p",
  null,
  "5.7 million refugees covered by our protection mandate.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/protection",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref25 = Object(preact_min["h"])("i", { className: "fas fa-piggy-bank" });

var _ref26 = Object(preact_min["h"])(
  "span",
  null,
  "Microfinance"
);

var _ref27 = Object(preact_min["h"])(
  "p",
  null,
  "Over 475,000 microfinance loans awarded to provide sustainable income-generation opportunities for Palestine refugees.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/microfinance",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref28 = Object(preact_min["h"])("i", { className: "fas fa-user-tie" });

var _ref29 = Object(preact_min["h"])(
  "span",
  null,
  "Vocational training"
);

var _ref30 = Object(preact_min["h"])(
  "p",
  null,
  "Percentage of UNRWA vocational training students who secure jobs after graduation 80%.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/vocational-training?program=33",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref31 = Object(preact_min["h"])("i", { className: "fas fa-graduation-cap" });

var _ref32 = Object(preact_min["h"])(
  "span",
  null,
  "Education"
);

var _ref33 = Object(preact_min["h"])(
  "p",
  null,
  "Over 500,000 students enrolled at UNRWA schools.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/education",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref34 = Object(preact_min["h"])("i", { className: "fas fa-campground" });

var _ref35 = Object(preact_min["h"])(
  "span",
  null,
  "Infrastructure and Camp Improvement"
);

var _ref36 = Object(preact_min["h"])(
  "p",
  null,
  "Infrastructure and Camp Improvement in the 58 official Palestine refugee camps in Jordan, Lebanon, Syria, the West Bank and the Gaza Strip.",
  Object(preact_min["h"])(
    "a",
    {
      href: "https://www.unrwa.org/what-we-do/infrastructure-camp-improvement",
      target: "_blank",
      rel: "noreferrer"
    },
    " ",
    "More information"
  ),
  "."
);

var _ref37 = Object(preact_min["h"])("img", { src: "/static/assets/images/home_logo.png", alt: "United Nations" });

var _ref38 = Object(preact_min["h"])(
  "ul",
  null,
  Object(preact_min["h"])(
    "li",
    null,
    Object(preact_min["h"])(
      "a",
      { alt: "United Nations", href: "https://www.unrwa.org/" },
      "About us"
    )
  ),
  Object(preact_min["h"])(
    "li",
    null,
    Object(preact_min["h"])(
      "a",
      {
        alt: "United Nations",
        href: "https://www.un.org/sustainabledevelopment/sustainable-development-goals/"
      },
      "Sustainable Development Goals"
    )
  ),
  Object(preact_min["h"])(
    "li",
    null,
    Object(preact_min["h"])(
      "a",
      { alt: "United Nations", href: "mailto:iati@unrwa.org" },
      "Contact us"
    )
  )
);

var _ref39 = Object(preact_min["h"])(
  "p",
  null,
  "Copyright \xA9 United Nations Relief and Works Agency for Palestine Refugees in the Near East"
);

var main_Main = function (_Component) {
  main__inherits(Main, _Component);

  function Main() {
    main__classCallCheck(this, Main);

    return main__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Main.prototype.render = function render() {
    var _props = this.props,
        headerSelectedYear = _props.headerSelectedYear,
        onSelectHeaderYear = _props.onSelectHeaderYear,
        isLoadingYearSummary = _props.isLoadingYearSummary,
        yearSummaryData = _props.yearSummaryData;

    return Object(preact_min["h"])(
      "div",
      { className: style_default.a.mainWrapper },
      Object(preact_min["h"])(
        "div",
        { className: style_default.a.headerWrapper },
        Object(preact_min["h"])(
          "div",
          { className: style_default.a.headerNavbarWrapper },
          main__ref,
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "ul",
              null,
              Object(preact_min["h"])(
                "li",
                null,
                Object(preact_min["h"])(
                  "a",
                  {
                    alt: "United Nations",
                    href: "/",
                    className: style_default.a.headerActiveLink
                  },
                  "Home"
                )
              ),
              main__ref2,
              main__ref3,
              main__ref4
            )
          ),
          Object(preact_min["h"])(
            "div",
            { style: { display: "none" } },
            main__ref5
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: style_default.a.headerColumns },
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.headerFirstWrapper },
              main__ref6,
              main__ref7,
              Object(preact_min["h"])(
                "div",
                {
                  className: style_default.a.headerSearchBar,
                  style: { display: "none" }
                },
                main__ref8,
                main__ref9
              )
            )
          ),
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.headerSecondWrapper },
              Object(preact_min["h"])(yearSelector["a" /* default */], {
                selectedYear: headerSelectedYear,
                onSelectYear: onSelectHeaderYear
              }),
              isLoadingYearSummary ? Object(preact_min["h"])(
                "div",
                { className: style_default.a.headerCountersLoadingWrapper },
                main__ref10
              ) : Object(preact_min["h"])(
                "div",
                null,
                Object(preact_min["h"])(
                  "div",
                  { className: style_default.a.headerCountersWrapper },
                  Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(
                      "b",
                      null,
                      Object(utils["a" /* formatNumber */])(yearSummaryData.budgets / 1000000),
                      "m"
                    ),
                    main__ref11
                  ),
                  Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(
                      "b",
                      null,
                      Object(utils["a" /* formatNumber */])(yearSummaryData.expenses / 1000000),
                      "m"
                    ),
                    main__ref12
                  )
                ),
                Object(preact_min["h"])(
                  "div",
                  { className: style_default.a.headerCountersWrapper },
                  Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(
                      "b",
                      null,
                      Object(utils["b" /* formatNumberNoFractionDigits */])(yearSummaryData.activities)
                    ),
                    main__ref13
                  ),
                  Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(
                      "b",
                      null,
                      Object(utils["b" /* formatNumberNoFractionDigits */])(yearSummaryData.donors)
                    ),
                    main__ref14
                  )
                )
              ),
              Object(preact_min["h"])(
                "p",
                { className: style_default.a.headerCountersInformation },
                "* The donor count includes only donors who have already provided consent to publish contributions to the IATI web portal."
              )
            )
          )
        )
      ),
      Object(preact_min["h"])(
        "div",
        { style: { marginTop: "3rem", marginBottom: "3rem" } },
        main__ref15,
        main__ref16
      ),
      Object(preact_min["h"])(
        "div",
        { className: style_default.a.listSectionWrapper },
        Object(preact_min["h"])(
          "div",
          { className: style_default.a.listMainTitleWrapper },
          _ref17,
          _ref18
        ),
        Object(preact_min["h"])(
          "div",
          { className: style_default.a.listColumnsWrapper },
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref19,
              _ref20
            ),
            _ref21
          ),
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref22,
              _ref23
            ),
            _ref24
          ),
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref25,
              _ref26
            ),
            _ref27
          )
        ),
        Object(preact_min["h"])(
          "div",
          { className: style_default.a.listColumnsWrapper },
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref28,
              _ref29
            ),
            _ref30
          ),
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref31,
              _ref32
            ),
            _ref33
          ),
          Object(preact_min["h"])(
            "div",
            null,
            Object(preact_min["h"])(
              "div",
              { className: style_default.a.listTitleWrapper },
              _ref34,
              _ref35
            ),
            _ref36
          )
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: style_default.a.footerSectionWrapper },
        _ref37,
        _ref38,
        _ref39
      )
    );
  };

  return Main;
}(preact_min["Component"]);

/* harmony default export */ var main = (main_Main);
// EXTERNAL MODULE: ./routes/home/actions/index.js
var actions = __webpack_require__("Cic2");

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/home/index.js


function home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function home__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var home_Home = function (_Component) {
  home__inherits(Home, _Component);

  function Home(props) {
    home__classCallCheck(this, Home);

    var _this = home__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      headerSelectedYear: Object(utils["c" /* getCurrentYear */])(_this.props.generalInfo)
    };
    _this.onSelectHeaderYear = _this.onSelectHeaderYear.bind(_this);
    return _this;
  }

  Home.prototype.componentDidMount = function componentDidMount() {
    var fetchYearSummary = this.props.fetchYearSummary;

    fetchYearSummary(this.props.globalSelectedYear);
  };

  Home.prototype.onSelectHeaderYear = function onSelectHeaderYear(headerSelectedYear) {
    var fetchYearSummary = this.props.fetchYearSummary;

    this.setState({ headerSelectedYear: headerSelectedYear });
    this.props.setCurrentYear(headerSelectedYear);
    fetchYearSummary(headerSelectedYear);
  };

  Home.prototype.render = function render() {
    var _state = this.state,
        headerSelectedYear = _state.headerSelectedYear,
        selectedYear = _state.selectedYear;
    var _props = this.props,
        isLoadingYearSummary = _props.isLoadingYearSummary,
        yearSummaryData = _props.yearSummaryData,
        yearSummaryError = _props.yearSummaryError;

    return Object(preact_min["h"])(main, {
      isLoadingYearSummary: isLoadingYearSummary,
      yearSummaryData: yearSummaryData,
      yearSummaryError: yearSummaryError,
      headerSelectedYear: this.props.globalSelectedYear,
      onSelectHeaderYear: this.onSelectHeaderYear
    });
  };

  return Home;
}(preact_min["Component"]);

var home_mapStateToProps = function mapStateToProps(state) {
  return {
    isLoadingYearSummary: state.home.yearSummary.loading,
    yearSummaryData: state.home.yearSummary.data,
    generalInfo: state.generalInfo.data,
    globalSelectedYear: state.yearList.currentYear
  };
};

var home_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchYearSummary: function fetchYearSummary(year) {
      return dispatch(Object(actions["d" /* fetchYearSummary */])(year));
    },
    setCurrentYear: function setCurrentYear(year) {
      return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
    }
  };
};

/* harmony default export */ var home = __webpack_exports__["default"] = (Object(preact_redux_esm["b" /* connect */])(home_mapStateToProps, home_mapDispatchToProps)(home_Home));

/***/ }),

/***/ "qVNc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__C_lJR","headerWrapper":"headerWrapper__1xffL","headerNavbarWrapper":"headerNavbarWrapper__24f1k","headerActiveLink":"headerActiveLink__2yezM","headerColumns":"headerColumns__29LW6","headerFirstWrapper":"headerFirstWrapper__fSm-B","headerSearchBar":"headerSearchBar__nwfM8","headerSecondWrapper":"headerSecondWrapper__3XoGU","headerCountersLoadingWrapper":"headerCountersLoadingWrapper__3Mkw6","rotating":"rotating__bJg2c","headerCountersWrapper":"headerCountersWrapper__mIm5Y","headerCountersInformation":"headerCountersInformation__1EGVg","listSectionWrapper":"listSectionWrapper__2_b3l","listMainTitleWrapper":"listMainTitleWrapper__1b5gv","listColumnsWrapper":"listColumnsWrapper__2qA_t","listTitleWrapper":"listTitleWrapper__3awLS","footerSectionWrapper":"footerSectionWrapper__16rUv"};

/***/ }),

/***/ "rhVT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__2VGmH"};

/***/ })

});


// WEBPACK FOOTER //
// route-home.chunk.94492.js